<style scoped>
  form {
    margin: 0;
    padding: 0;
    border: none;
  }
</style>
<template>
  <form :rules="rules"
        type="type"
        :name="name"
        :class="className"
        :way="way"
  >
    <slot></slot>
  </form>
</template>

<script>
  export default {
    name: 'HForm',
    componentName: 'HForm',
    props: {
      // 验证规则
      rules: Object,
      className: String,
      model: Object,
      name: String,
      labelWidth: {
        type: [String, Number]
      },
      way: {
        // 验证执行方式
        // true 只要遇到验证错误，将停止向下验证
        // false 会一直向下验证
        type: Boolean,
        default: false
      },
      // 为 true 时
      type: Boolean
    },
    methods: {
      handleValidator(components, valid, message) {
        for(let i = 0, len = components.length; i < len; i++) {
          if(components[i].$options.componentName === "HInput") {
            if(components[i].handleTrigger && typeof components[i].valid !== 'undefined') {
              components[i].handleTrigger();
              if(!components[i].valid) {
                valid = false;
                message = components[i].errorMeg;
              }
              if(this.way && !valid) {
                break;
              }
            }
          } else if(components[i].$children && components[i].$children.length > 0) {
            this.handleValidator(components[i].$children, valid, message)
          }
        }

        return {
          valid,
          message
        }
      },
      /**
       * 调用每个组件的事件并触发
       * @param callback
       */
      validator(callback) {
        let valid = true;
        let message = '';
        let components = this.$children;

        let o = this.handleValidator(components, valid, message);

        callback && callback(o.valid, o.message);
      },
      handleFieldValidator(propNameArr, components, valid, message) {
        for(let i = 0, len = components.length; i < len; i++) {
          if(components[i].$options.componentName === "HInput") {
            if(propNameArr.indexOf(components[i].prop) > -1 && components[i].handleTrigger) {
              components[i].handleTrigger();
              if(!components[i].valid) {
                valid = false;
                message = components[i].errorMeg;
              }
              if(this.way && !valid) {
                break;
              }
            }
          } else if(components[i].$children && components[i].$children.length > 0) {
            this.handleFieldValidator(propNameArr, components[i].$children, valid, message)
          }
        }
        return {
          valid,
          message
        }
      },
      /**
       * 调用单个组件事件并触发
       * @param propNameArr 调用组件的对应 prop 值 支持 Array（多个组件名）
       * @param callback
       */
      validateRegion(propNameArr, callback) {
        //判断propNameArr类型
        if(({}).toString.call(propNameArr).toLocaleLowerCase() === '[object string]') {
          propNameArr = [propNameArr];
        }
        let valid = true;
        let message = '';
        let components = this.$children;
        let o = this.handleFieldValidator(propNameArr, components, valid, message);

        callback && callback(o.valid, o.message);
      },
      /**
       * 格式化表单
       */
      reset(children) {
        let components = children || this.$children;
        for(let i = 0, len = components.length; i < len; i++) {
          if(components[i].$options.componentName === "HInput") {
            components[i].updateValue('');
            components[i].valid = true;
            components[i].isError = false;
            components[i].messageError('');
          } else if(components.$children && components.$children.length > 0) {
            this.reset(components.$children)
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Form/HForm.vue